<template>
    <div class="moon-footer">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name:'MoonFooter'
    };
</script>

<style lang="scss" scoped>

</style>